import styled from 'styled-components'
import Dialog from '@material-ui/core/Dialog'

import { Colors, FontSize } from '~/styles'

const ConfirmDialog = styled(Dialog)`
  div.MuiDialog-container.MuiDialog-scrollPaper {
    div.MuiDialog-paperWidthMd {
      width: ${(props) => props.width}vw;
      max-width: none;
      padding: 24px;
      ${(props) => props.height ? `height: ${props.height}${props.heightType ? props.heightType : 'vh'};` : ''}
    }
    div.MuiDialog-paperWidthXl {
      width: ${(props) => props.width}vw;
    }
  }
`

const ConfirmContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
`

const ConfirmAction = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  justify-content: center;
`

const ConfirmIcon = styled.img`
  width: 96px;
  height: 96px;
`

const ConfirmTitle = styled.h4`
  margin: 0;
  color: ${Colors.cancelTextColor};
  font-weight: bold;
  font-size: ${FontSize.extraLarge}px;
`

const ConfirmDesc = styled.h2`
  color: ${Colors.modalGrey};
  font-size: ${FontSize.medium}px;
  text-align: center;
  margin-top: 0;
  font-weight: 400;
  margin-bottom: 24px;
`

export default {
  ConfirmIcon,
  ConfirmDesc,
  ConfirmTitle,
  ConfirmDialog,
  ConfirmAction,
  ConfirmContent,
}